import { cloneElement, isValidElement, useRef } from "react";
import './FileUploader.css';

export const FileUploader = ({ onUpload, label, children, iconLabel, disable = false, ...props }) => {

  const fileInputRef = useRef();

  const handleButtonClick = () => {
    if (disable) {
      return;
    }
    fileInputRef.current.click(); // Trigger the hidden file input
  };

  const handleFileChange = (event) => {
    onUpload?.(event);
    const file = event.target.files[0];
    if (file) {
      // You can now upload the file using fetch or axios
    }
  };

  return (
    <>

      {isValidElement(children) ? cloneElement(children, {
        onClick: handleButtonClick
      }) : <div className='file-uploader-component'
        style={{ cursor: disable ? 'not-allowed' : 'pointer' , background : disable ? 'var(--disabled-input-bg)' : 'var(--white)' }}
        onClick={handleButtonClick}>
        <i className={!iconLabel ? "icon-upload" : iconLabel}></i>
        {label || "Upload File"}
      </div>}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        // accept="image/*"
        {...props}
      />
    </>
  )
}